import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { deleteShipCalPackage, getShipmentCalApi } from '../../apiHelper/authService';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { setSelectedCalPackage } from '../../redux/authModalSlice';

const ShippingCalTableV2 = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const [selectedPackageId, setSelectedPackageId] = useState(null);

    const dispatch = useDispatch()


    const [itemsPerPage] = useState(8);


    const { user } = useSelector((state) => state.authModal);
    // const [categories, setCategories] = useState();
    const [packageData, setPackageData] = useState();



    const fromCountry = user?.from;
    const toCountry = user?.to;




    // console.log("UserData:", fromCountry)

    const [loading, setLoading] = useState(false);
    // useEffect(() => {
    //     const table = $('#dataTable').DataTable({
    //         pageLength: 10,
    //     });
    //     return () => {
    //         table.destroy(true);
    //     };
    // }, []);




    const getShipCalPackage = async () => {
        setLoading(true);



        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            const data = await getShipmentCalApi();
            // setCategories(data);
            setPackageData(data)
            // toast.success("Email Templates fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching email templates.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {

        getShipCalPackage()


    }, [])



    // console.log(packageTableData)

    const packageTableData = packageData || []
    console.log(packageTableData)


    const [searchQuery, setSearchQuery] = useState("");


    const filteredData = packageTableData?.filter((item) =>
        Object.values(item).some((val) =>
            String(val).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    const totalItems = filteredData?.length || 0;
    const itemsPerPageSafe = itemsPerPage || 1;
    const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
    const startIdx = (currentPage - 1) * itemsPerPage;
    const currentItems = filteredData?.slice(startIdx, startIdx + itemsPerPage);

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleConfirmDelete = async () => {
        if (!selectedPackageId) return;

        setLoading(true);



        const toastId = toast.loading("Deleting...");

        try {
            const data = await deleteShipCalPackage({ id: selectedPackageId });
            getShipCalPackage()

            toast.success("Deleted", { id: toastId });
            const modalEl = document.getElementById('exampleModalEdit');
            const modalBackdrop = document.querySelector('.modal-backdrop');

            modalEl.classList.remove('show');
            modalEl.style.display = 'none';
            modalEl.setAttribute('aria-hidden', 'true');

            if (modalBackdrop) modalBackdrop.remove();
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err?.message || "Something went wrong while fetching categories.",
                { id: toastId }
            );
        } finally {
            setLoading(false);
            // setSelectedCategoryId(null)
        }

    }


    return (

        <>
            <div className="col-lg-12">
                <div className="card">
                    {/* <div className="card-header">
                    <h5 className="card-title mb-0">Shipment Calculation</h5>
                </div> */}

                    <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                        <div className="d-flex align-items-center flex-wrap gap-3">

                            <form className="navbar-search">
                                <input
                                    type="text"
                                    className="bg-base h-40-px w-auto"
                                    name="search"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                <Icon icon="ion:search-outline" className="icon" />
                            </form>

                        </div>
                        <Link
                            to={"/add-shipment-package"}
                            className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                        >
                            <Icon
                                icon="ic:baseline-plus"
                                className="icon text-xl line-height-1"
                            />
                            Add New Shipment Package
                        </Link>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive" style={{minHeight:"60vh"}}>
                            <table className="table vertical-striped-table mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col">Package Weight</th>
                                        <th scope="col">		Air Duration</th>
                                        <th scope="col">		Air Amount</th>
                                        <th scope="col">		Ship Duration</th>

                                        <th scope="col">		Ship Amount</th>
                                        <th scope="col">	Per KG Air Cost</th>
                                        <th scope="col">		Per KG Ship Cost</th>






                                        {/* <th scope="col">Publish</th> */}
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems?.length > 0 ? (


                                        currentItems?.map((pkageDta) => (
                                            <tr key={pkageDta.id}>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                                            {pkageDta.package_weight} KG
                                                        </h6>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >
                                                            {pkageDta.air_duration} DAYS
                                                        </h6>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1"


                                                        >
                                                            {/* {stripHtml(email.message)} */}
                                                            ${pkageDta?.air_amount}
                                                        </h6>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >
                                                            {/* {email.subject} */}
                                                            {pkageDta?.ship_duration} DAYS
                                                        </h6>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >
                                                            $ {pkageDta?.ship_amount}
                                                        </h6>
                                                    </div>
                                                </td>


                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >
                                                            ${pkageDta?.costPerKGAir.toFixed(2)}
                                                        </h6>
                                                    </div>
                                                </td>

                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <h6
                                                            className="text-md mb-0 fw-medium flex-grow-1 "


                                                        >
                                                            ${pkageDta?.costPerKGShip.toFixed(2)}
                                                        </h6>
                                                    </div>
                                                </td>





                                                <td>
                                                    <Link
                                                        to={"/add-shipment-package"}
                                                        onClick={() => dispatch(setSelectedCalPackage(pkageDta))}
                                                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                    >
                                                        <Icon icon="lucide:edit" />
                                                    </Link>
                                                    <Link
                                                        onClick={() => setSelectedPackageId(pkageDta.id)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#exampleModalEdit"

                                                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                                    >
                                                        <Icon icon="mingcute:delete-2-line" />
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))


                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center py-16 text-muted">
                                                No Shipping Calculator Package  found.
                                            </td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>


                        </div>

                        {filteredData?.length > itemsPerPage &&


                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
                                <span>
                                    Showing {startIdx + 1} to{" "}
                                    {Math.min(startIdx + itemsPerPage, filteredData?.length)} of{" "}
                                    {filteredData?.length} entries
                                </span>
                                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            <Icon icon="ep:d-arrow-left" className="text-xl" />
                                        </button>
                                    </li>

                                    {[...Array(totalPages)].map((_, index) => (
                                        <li className="page-item" key={index}>
                                            <button
                                                className={`page-link ${currentPage === index + 1
                                                    ? "bg-primary-600 text-white"
                                                    : "bg-primary-50 text-secondary-light"
                                                    } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                                                onClick={() => goToPage(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}

                                    <li className="page-item">
                                        <button
                                            className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                                            onClick={() => goToPage(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            <Icon icon="ep:d-arrow-right" className="text-xl" />
                                        </button>
                                    </li>
                                </ul>
                            </div>}
                    </div>
                </div>
                {/* card end */}
            </div>
            <div
                className="modal fade"
                id="exampleModalEdit"
                tabIndex={-1}
                aria-labelledby="exampleModalEditLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                                Confirm Deletion
                            </h1>
                            <button

                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body p-24 text-center">
                            <p className="mb-4 fs-6 text-secondary">
                                Are you sure you want to delete this item?
                            </p>
                            <div className="d-flex justify-content-center gap-3 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={handleConfirmDelete}
                                >
                                    Confirm
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default ShippingCalTableV2